import { Dropdown, List, Thumbnail } from '@bynder/design-system';
import { Color } from '../../../types/color';

const LIST_ITEM_HEIGHT = '56px';

const InspectorPanelColorPicker = ({
  testId,
  defaultColorHex,
  activeColor,
  handleClick,
  handleClear = () => {},
  label,
  colors,
}: {
  testId?: string;
  defaultColorHex?: string;
  activeColor?: Color;
  handleClick: (colorId: string | null) => void;
  handleClear: () => void;
  label?: string;
  showTransparent?: boolean;
  colors: Color[];
}) => {
  return (
    <div style={{ height: LIST_ITEM_HEIGHT }} data-testid={testId}>
      <Dropdown
        trigger={({ isOpen, ...triggerProps }) =>
          activeColor ? (
            <List.Item
              data-testid={testId}
              isSelected={isOpen}
              rightElements={<Dropdown.Arrow />}
              subtext={label ? activeColor.label : activeColor.hexCode}
              isDisabled={!colors.length}
              thumbnail={
                <Thumbnail
                  size="s"
                  variant="content"
                  shape="circle"
                  backgroundColor={activeColor.hexCode}
                />
              }
              {...triggerProps}
            >
              {label ? label : activeColor.label}
            </List.Item>
          ) : (
            <List.Item
              rightElements={<Dropdown.Arrow />}
              {...triggerProps}
              thumbnail={
                <Thumbnail
                  size="s"
                  variant="content"
                  shape="circle"
                  backgroundColor={defaultColorHex}
                />
              }
            >
              {label}
            </List.Item>
          )
        }
        position="bottom"
      >
        <Dropdown.ListItem
          isChecked={!activeColor}
          onClick={handleClear}
          thumbnail={
            <Thumbnail
              size="s"
              variant="content"
              shape="circle"
              backgroundColor={defaultColorHex}
            />
          }
        >
          Default Color
        </Dropdown.ListItem>

        <Dropdown.Divider />
        {colors.map(color => (
          <Dropdown.ListItem
            key={color.id}
            thumbnail={
              <Thumbnail
                size="s"
                variant="content"
                shape="circle"
                backgroundColor={color.hexCode}
              />
            }
            isChecked={activeColor?.id === color.id}
            subtext={color.hexCode}
            onClick={() => handleClick(color.id)}
          >
            {color.label}
          </Dropdown.ListItem>
        ))}
      </Dropdown>
    </div>
  );
};

export default InspectorPanelColorPicker;
